/* script */
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'DocumentTab',

    props: {
        tab: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            fresh: this.tab.id.startsWith('TEMP:'),
            tabName: null,
            eid: this.event.id || this.event._id,
            typeIcon: this.$utils.assets.getIconForType(this.tab.type),
        };
    },

    computed: {
        name() {
            const { type } = this.tab;
            if (type === 'doc') {
                return this.docName();
            }

            if (type === 'diff') {
                return this.diffName();
            }

            return '';
        },

        ready() {
            if (this.tab.type === 'doc') {
                return this.tab.data && Boolean(this.name.length);
            }

            return Boolean(this.name.length);
        }
    },

    watch: {
        tab: {
            immediate: true,
            handler() {
                this.init();
            }
        },

        'tab.data': {
            deep: true,
            handler() {
                this.init();
            }
        }
    },

    methods: {
        async init() {
            if (this.tab.type === 'doc' && this.tab.data) {
                await this.initDoc();
            }
        },

        async initDoc() {
            const doc = this.tab.data;
            const type = doc.fp_type;

            if (type) {
                this.typeIcon = this.$utils.assets.getIconForType(type);

                const metadata = await this.$services.metadata.getMetadataForType(this.eid, type, true);
                if (metadata._representation) {
                    this.tabName = this.$utils.dom.compile(metadata._representation, doc);
                }
            }

            if (doc.type && doc.type === '4p_event') {
                this.typeIcon = this.$utils.assets.getIconForType(doc.type);
                this.tabName = this.$utils.workspaces.getWorkspaceTitle(this.event);
            }
        },

        docName() {
            const doc = this.tab.data || {};
            let name =
                this.tabName ||
                doc.title ||
                doc.name ||
                doc.template_name ||
                doc.email ||
                doc.pkg ||
                doc._id;

            if (!name && this.fresh) {
                name = this.$i18n.t('dev_tools.document_editor.new_doc');
            }

            if (doc.fp_type === 'package_install_report') {
                name = `${name}@${doc.version}`;
            }

            return name || this.tab.id;
        },

        diffName() {
            const [, docId, revA, revB] = this.tab.id.split(':');
            const [n1] = revA.split('-');
            const [n2] = revB.split('-');

            return `${docId.substring(0, 6)}@${n1}vs${n2}`;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-tab",class:{ ready: _vm.ready },on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.typeIcon)?_c('i',{class:_vm.typeIcon}):_vm._e(),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tab.id),expression:"tab.id"}],staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),(!_vm.tab.changed || _vm.fresh)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('general.close')),expression:"$t('general.close')"}],staticClass:"ic-x",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}}):_vm._e(),(_vm.tab.changed && !_vm.fresh)?_c('i',{staticClass:"ic-upload-cloud"}):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DocumentTab.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__